export default __webpack_public_path__ + "static/media/GothamSSm-Medium.53bbf9e0.eot";